import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { attachedDocumentToAuditsOrCases, TOGGLE_ATTACHED_AUDIT_CASE_POPUP } from "./reducers/emdr-ibox-reducer";
import MdaePopup, {
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
  MdaePopupTitle,
} from "../../../common_components/common_widgets/popup";
import MdaeButton from "../../../common_components/common_widgets/button";
import AuditList from "../../external-audit/audit-list";
import $ from "jquery";
import dxDataGrid from "devextreme/ui/data_grid";
import { CLEAR_SELECTED_CASE_DETAIL_IDS_TO_ADD_TO_AUDIT } from "../../../common_components/case-details/reducers/ea-case-fields-reducer";
import {
  AUDIT_LIST_TYPE,
  EMDR_ATTACH_POPUP_MODE,
} from "../constant";
import { SET_LEVEL_GRID_SEARCH_ENABLED } from "../../external-audit/audit-list/reducers/audit-list-reducer";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../../common_components/common_widgets/toast/notify";

interface IAttachedDocumentToAuditOrCase {}

export const toggleAttachedDocumentToAuditOrCasePopup = (
  dispatch,
  isVisible,
  documentId,
  popupMode = EMDR_ATTACH_POPUP_MODE.ATTACH_DOCUMENT
) => {
  dispatch({
    type: TOGGLE_ATTACHED_AUDIT_CASE_POPUP,
    data: {
      isAttachedDocumentToAuditOrCasePopupVisible: isVisible,
      attachPopupMode: isVisible
        ? popupMode
        : EMDR_ATTACH_POPUP_MODE.ATTACH_DOCUMENT,
    },
  });
  if (isVisible) {
    dispatch({
      type: TOGGLE_ATTACHED_AUDIT_CASE_POPUP,
      data: {
        documentId: documentId,
      },
    });
  } else {
    dispatch({
      type: TOGGLE_ATTACHED_AUDIT_CASE_POPUP,
      data: {
        documentId: null,
      },
    });
  }
  dispatch({
    type: SET_LEVEL_GRID_SEARCH_ENABLED,
    data: {
      auditListSearchText: "",
    },
  });
  if (popupMode === EMDR_ATTACH_POPUP_MODE.ADD_CASES) {
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        isCaseLevelGridSearchEnabled: false,
        isAuditWithCasesFetched: false,
      },
    });
  }
  const auditCaseListDataGridInstance = dxDataGrid.getInstance(
    $("#pnlAuditcaseListDetails") as any
  ) as dxDataGrid;
  const auditListDataGridInstance = dxDataGrid.getInstance(
    $("#pnlAuditList") as any
  ) as dxDataGrid;

  if (!isVisible && auditCaseListDataGridInstance) {
    dispatch({
      type: CLEAR_SELECTED_CASE_DETAIL_IDS_TO_ADD_TO_AUDIT,
    });
  }
  if (isVisible && auditListDataGridInstance) {
    auditListDataGridInstance.deselectAll();
    auditCaseListDataGridInstance.deselectAll();
  }
};

const AttachedDocumentToAuditOrCase: React.FC<IAttachedDocumentToAuditOrCase> = (
  props
) => {
  console.log("AttachedDocumentToAuditOrCase  Rendered");
  const dispatch = useDispatch();

  const [auditListDataGridInstance, setauditListDataGridInstance] = useState<dxDataGrid>(null);

  const documentId = useSelector(
    (state) => state["emdrInboxReducer"].documentId
  );

  const isAttachedDocumentToAuditOrCasePopupVisible = useSelector(
    (state) =>
      state["emdrInboxReducer"].isAttachedDocumentToAuditOrCasePopupVisible
  );
  const attachPopupMode = useSelector((state) => state["emdrInboxReducer"].attachPopupMode) ?? EMDR_ATTACH_POPUP_MODE.ATTACH_DOCUMENT;
  const isAddCaseMode = (attachPopupMode === EMDR_ATTACH_POPUP_MODE.ADD_CASES);
  useEffect(() => {
    if(isAttachedDocumentToAuditOrCasePopupVisible)
      setauditListDataGridInstance(
        dxDataGrid.getInstance($("#pnlAuditList") as any) as dxDataGrid
      );
  });

  const getAttachedDocumentToAuditOrCasePopupTitle = useCallback(() => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          toggleAttachedDocumentToAuditOrCasePopup(dispatch, false, documentId);
          dispatch({
            type: SET_LEVEL_GRID_SEARCH_ENABLED,
            data: {
              auditListSearchText: ""
            },
          });
        }}
      >
        {isAddCaseMode
          ? "Add Case(s) to Audit"
          : "Attach to Audit/Case"}
      </MdaePopupTitle>
    );
  }, [documentId]);


  return (
    <MdaePopup
      deferRendering={false}
      height={700}
      width={1500}
      className="emdr-inbox-container"
      titleRender={getAttachedDocumentToAuditOrCasePopupTitle}
      visible={isAttachedDocumentToAuditOrCasePopupVisible}
      mdaeContentRenderComponent={<AttachDocumentPopupContentRender />}
      mdaeFooterRenderComponent={
        <AttachDocumentFooterContentRender
          auditListDataGridInstance={auditListDataGridInstance}
          documentId={documentId}
          attachPopupMode={attachPopupMode}
        />
      }
    />
  );
};
interface IAttachDocumentPopupContentRenderProps {

}
const AttachDocumentPopupContentRender: React.FC<IAttachDocumentPopupContentRenderProps> = ({
}) => {
  const documentId = useSelector(
    (state) => state["emdrInboxReducer"].documentId
  );

  const isAttachedDocumentToAuditOrCasePopupVisible = useSelector(
    (state) =>
      state["emdrInboxReducer"].isAttachedDocumentToAuditOrCasePopupVisible
  );
  const attachPopupMode = useSelector((state) => state["emdrInboxReducer"].attachPopupMode) ?? EMDR_ATTACH_POPUP_MODE.ATTACH_DOCUMENT;
  const isAddCaseMode = (attachPopupMode === EMDR_ATTACH_POPUP_MODE.ADD_CASES);

  return (
    <MdaePopupContent>
      {isAttachedDocumentToAuditOrCasePopupVisible && (
        <AuditList
          type={AUDIT_LIST_TYPE.EMDR_TYPE}
          doumentId={documentId}
          hideCases={isAddCaseMode}
          selectionModeOverride={isAddCaseMode ? "single" : "multiple"}
        ></AuditList>
      )}
    </MdaePopupContent>)
};
interface IAttachDocumentFooterContentRender {
  auditListDataGridInstance: dxDataGrid;
  documentId: string;
  attachPopupMode: string;
}
const AttachDocumentFooterContentRender :React.FC<IAttachDocumentFooterContentRender>=({
  auditListDataGridInstance,
  documentId,
  attachPopupMode})=>{
    const dispatch = useDispatch();
    const isAddCaseMode = attachPopupMode === EMDR_ATTACH_POPUP_MODE.ADD_CASES;
    const primaryButtonLabel = isAddCaseMode ? "Add" : "Attach";

    const handleAddCaseSelection = () => {
      const selectedAudits = auditListDataGridInstance?.getSelectedRowsData() ?? [];
      if (!selectedAudits.length) {
        mdaeNotify({
          message: "Select at least one audit to continue.",
          messageType: NOTIFY_MESSAGE_TYPE.WARNING,
        });
        return;
      }
      const selectedAudit = selectedAudits[0];
      const auditId = selectedAudit?.eaAuditId;
      if (!auditId) {
        mdaeNotify({ message: "Unable to determine selected audit.", messageType: NOTIFY_MESSAGE_TYPE.ERROR, });
        return;
      }

      toggleAttachedDocumentToAuditOrCasePopup(dispatch, false, documentId);

      const caseSearchUrl = `${
        window.location.origin
      }/externalaudit/audit?auditId=${auditId}&openCaseSearchFromEmdr=true&documentid=${documentId ?? 0}`;

      const newTab = window.open(caseSearchUrl, "_blank");
      if (!newTab) {
        window.location.href = caseSearchUrl;
      }
    };

  return (
    <MdaePopupFooter>
      <MdaePopupFooterStartButtons>
        <MdaeButton
          id={"btnCancelAddCaseManualPopup"}
          role={"secondary"}
          onClick={() => {
            toggleAttachedDocumentToAuditOrCasePopup(
              dispatch,
              false,
              documentId
            );
            auditListDataGridInstance.deselectAll();
          }}
        >
          Cancel
        </MdaeButton>
      </MdaePopupFooterStartButtons>
      <MdaePopupFooterEndButtons>
        <MdaeButton
          id={"btnSaveAddCaseManualPopup"}
          role={"primary"}
          onClick={() => {
            if (isAddCaseMode) {
              handleAddCaseSelection();
              return;
            }
            dispatch(attachedDocumentToAuditsOrCases(auditListDataGridInstance));
          }}
        >
          {primaryButtonLabel}
        </MdaeButton>
      </MdaePopupFooterEndButtons>
    </MdaePopupFooter>
  );
};
export default AttachedDocumentToAuditOrCase;
